import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { Button } from 'foundations-components/transitional/components/Button';
import { useState } from 'react';
import FreeFeatureTable from '../feature-table/suite-feature-table/FreeFeatureTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileFreeFeatureTable = ({
  screen,
  trackingSource
}) => {
  const [showFeatureTable, setShowFeatureTable] = useState(false);
  const toggleShowFeatureTable = evt => {
    evt.preventDefault();
    setShowFeatureTable(prev => !prev);
  };
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "100",
    children: [/*#__PURE__*/_jsx(Button, {
      use: "transparent",
      onClick: toggleShowFeatureTable,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: showFeatureTable ? 'suiteFeatureTable.mobile.hideAll' : 'suiteFeatureTable.mobile.seeAll'
      })
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      duration: 500,
      renderContent: () => /*#__PURE__*/_jsx(FreeFeatureTable, {
        screen: screen,
        trackingSource: trackingSource
      }),
      open: showFeatureTable
    })]
  });
};
export default MobileFreeFeatureTable;